/**
 * @param {string} data
 * @returns {string}
 */
function FormatBirth(data) {
  if (!data || data === "") {
    return "";
  }

  const numbers = data.replaceAll(/\D+/gi, "").substring(0, 8);

  if (numbers.length === 8) {
    return numbers.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");
  }

  return numbers;
}

export default FormatBirth;
